<template>
  <div class="notice" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          规划报告AI设置
        </el-text>
        <el-button-group>
          <el-button type="primary" @click="save()" :loading="loading.save">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="是否开启AI润色">
        <el-select v-model="data.notice2.content" style="width: 200px;">
          <el-option label="开启" value="ON" />
          <el-option label="关闭" value="OFF" />
        </el-select>
      </el-form-item>
      <el-form-item label="AI提示词设置">
        <el-input v-model="data.notice.content" style="width: 100%;" maxlength="60000" :rows="30" type="textarea" />
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'

const router = useRouter()
const loading = reactive({
  save: false,
})
const data = reactive({
  notice2: {
    type: 'USE_REPORT_AI',
    kkey: '',
    hasShow: true,
    title: '',
    content: '',
    sort: 0,
    file: '',
  },
  notice: {
    type: 'REPORT_AI',
    kkey: '',
    hasShow: true,
    title: '',
    content: '',
    sort: 0,
    file: '',
  },
  file: { file: [] },
})

const getSystem = () => {
  loading.save = true
  api.get('/backend/notice/getNoticeList', { params: { type: 'USE_REPORT_AI' } }).then((res) => {
    if (res.list.length > 0) {
      data.notice2 = res.list[0]
    }
  })
  api.get('/backend/notice/getNoticeList', { params: { type: 'REPORT_AI' } }).then((res) => {
    if (res.list.length > 0) {
      data.notice = res.list[0]
      data.file.file = util.json2Elfile(data.notice.file)
    }
    loading.save = false
  })
}
getSystem()

const save = () => {
  loading.save = true

  const notice2 = JSON.parse(JSON.stringify(data.notice2))
  notice2.file = util.elfile2Json(data.file.file)
  if (!data.notice2.id) {
    api.post('/backend/notice/addNotice', notice2)
  } else {
    notice2.createDatetime = null
    api.post('/backend/notice/setNotice', notice2)
  }

  const notice = JSON.parse(JSON.stringify(data.notice))
  notice.file = util.elfile2Json(data.file.file)
  if (!data.notice.id) {
    api.post('/backend/notice/addNotice', notice).then(() => {
      ElMessage.success('保存成功')
      getSystem()
    }).finally(() => {
      loading.save = false
    })
  } else {
    notice.createDatetime = null
    api.post('/backend/notice/setNotice', notice).then(() => {
      ElMessage.success('保存成功')
      getSystem()
    }).finally(() => {
      loading.save = false
    })
  }
}
</script>

<style lang="less">
.notice {
  margin: auto;
  max-width: 900px;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>